import React from "react";
import { withTranslation } from "react-i18next";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Button, CircularProgress, Grid } from "@mui/material";
import PropTypes from "prop-types";

import Modal from "Components/Common/Modal";
import InputFieldText from "Components/Common/InputFieldText";

import { useSetNewPasswordPutMutation } from "apis/OTP";

const ChangePasswordModal = ({ handleClose, userEmail, t }) => {
  const [setNewPassword, { isLoading: isPasswordUpdating }] =
    useSetNewPasswordPutMutation();

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      password: Yup.string().required("Password is required"),
      confirmPassword: Yup.string()
        .oneOf(
          [Yup.ref("password")],
          "Password and confirm password must be same"
        )
        .required("Confirm password is required"),
    }),
    onSubmit: async ({ password }) => {
      try {
        const payload = {
          username: userEmail,
          password,
        };
        await setNewPassword(payload, {}, true);
        handleClose();
      } catch (error) {}
    },
  });

  const { handleSubmit } = formik;

  return (
    <Modal
      handleClose={handleClose}
      isOpen
      maxWidth="sm"
      title="Change Password"
    >
      <div className="mt-3">
        <Grid item xs={12}>
          <InputFieldText
            label={t("Password") + "*"}
            placeholder="Enter Password"
            name="password"
            formik={formik}
          />
        </Grid>
        <Grid item xs={12}>
          <InputFieldText
            label={t("Confirm Password") + "*"}
            placeholder="Enter Confirm Password"
            name="confirmPassword"
            formik={formik}
          />
        </Grid>
        <Grid item xs={12} className="text-end mt-3">
          <Button
            onClick={handleSubmit}
            color="primary"
            className="mb-1 me-1"
            variant="contained"
            disabled={isPasswordUpdating}
          >
            {t("Submit")}
            {isPasswordUpdating && <CircularProgress size={20} />}
          </Button>
        </Grid>
      </div>
    </Modal>
  );
};

ChangePasswordModal.propTypes = {
  handleClose: PropTypes.func,
  userEmail: PropTypes.string,
  t: PropTypes.func,
};

export default withTranslation()(ChangePasswordModal);
